<mat-card class="validate-card">
    <mat-card-header>
        <mat-card-title><fa-icon [icon]="['fas','house-user']"></fa-icon>&nbsp;&nbsp;Adresse</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="flex-container" fxLayout="row" fxLayoutGap="5px">
            <mat-form-field fxFlex class="field-full-width">
                <mat-label>Adresse</mat-label>
                <input matInput [value]="patient.address" mat-autoresize="true" placeholder="Adresse du patient">
            </mat-form-field>
        </div>
        <div class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
            <mat-form-field fxFlex class="field-full-width">
                <mat-label>Code postal</mat-label>
                <input matInput [value]="patient.zip" mat-autoresize="true" placeholder="Code postal du patient">
            </mat-form-field>
            <mat-form-field fxFlex class="field-full-width">
                <mat-label>Commune</mat-label>
                <input matInput [value]="patient.city" mat-autoresize="true" placeholder="Commune du patient">
            </mat-form-field>
        </div>
        <div class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
            <mat-form-field fxFlex class="field-full-width">
                <mat-label>Mobile</mat-label>
                <input matInput [value]="patient.mobile" mat-autoresize="true" placeholder="Mobile du patient">
            </mat-form-field>
            <mat-form-field fxFlex class="field-full-width">
                <mat-label>Téléphone fixe</mat-label>
                <input matInput [value]="patient.phone" mat-autoresize="true" placeholder="Téléphone fixe du patient">
            </mat-form-field>
        </div>
    </mat-card-content>
</mat-card>
